import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getCollapsedGroups } from '../../reducers/app/collapsedGroups';
import { toggleGroup } from './lockingsActions';

import Group from './Group';

class GroupContainer extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { isCollapsed, toggleGroup, ...rest } = this.props;

		return (
			<Group {...rest} collapsed={isCollapsed} onToggle={toggleGroup} />
		);
	}
}

function mapStateToProps(state, ownProps) {
	const { locking } = ownProps;
	const collapsedGroups = getCollapsedGroups(state);
	const isCollapsed = collapsedGroups[locking.locking_id];

	return {
		isCollapsed
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	const { locking } = ownProps;
	return {
		toggleGroup: () => {
			dispatch(toggleGroup(locking.locking_id));
		}
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupContainer);



// WEBPACK FOOTER //
// ./src/js/plan/lockings/GroupContainer.js